import { Box, Text } from '@backstage/ui';
import styles from './badges.module.css';

const typeClassMap: Record<string, string> = {
  website: styles.typeWebsite,
  frontend: styles.typeFrontend,
  service: styles.typeService,
  backend: styles.typeBackend,
  library: styles.typeLibrary,
  documentation: styles.typeDocumentation,
};

export const TypeBadge = ({ type }: { type: string }) => {
  const variantClass = typeClassMap[type.toLowerCase()] || styles.typeDefault;
  return (
    <Box className={`${styles.badge} ${variantClass}`}>
      <Text variant="body-x-small">{type}</Text>
    </Box>
  );
};
